"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconPortalUser = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M20 18.683c0 .87-.277 1.557-.83 2.061c-.553.504-1.287.756-2.204.756H7.034c-.917 0-1.651-.252-2.204-.756c-.553-.504-.83-1.19-.83-2.06c0-.385.013-.76.04-1.126c.026-.366.08-.761.159-1.185c.08-.424.18-.818.301-1.18a5.47 5.47 0 01.489-1.06c.204-.345.439-.638.704-.881c.265-.243.59-.437.972-.582a3.55 3.55 0 011.267-.218c.068 0 .227.078.477.234c.25.156.532.33.847.522c.314.192.723.366 1.227.522c.504.156 1.01.234 1.517.234c.508 0 1.013-.078 1.517-.234c.504-.156.913-.33 1.227-.522c.315-.192.597-.366.847-.522c.25-.156.409-.234.477-.234c.462 0 .885.073 1.267.218c.383.145.707.339.972.582c.265.243.5.536.704.88c.205.345.368.698.489 1.06c.121.363.222.757.301 1.18c.08.425.133.82.16 1.186c.026.366.039.741.039 1.125zm-3.556-11.66c0 1.25-.434 2.316-1.302 3.2c-.868.883-1.915 1.325-3.142 1.325c-1.227 0-2.274-.442-3.142-1.326c-.868-.883-1.302-1.95-1.302-3.198c0-1.249.434-2.315 1.302-3.199C9.726 2.942 10.773 2.5 12 2.5c1.227 0 2.274.442 3.142 1.325c.868.884 1.302 1.95 1.302 3.199z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconPortalUser')(IconPortalUser);